<app-dialog-container>
    <div class="wizard-container" fxLayout="column" fxFlexFill>
        <mat-stepper [linear]="true" #stepper class="plan-stepper"
            fxFlex="auto">

            <mat-step *ngIf="planSelectionForm"
                [stepControl]="planSelectionForm" label="Plano">
                <ng-template matStepLabel>Selecionar Plano</ng-template>
                <div class="step-content" fxLayout="column">
                    <div fxFlex fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10px">
                        <mat-form-field appearance="outline" fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="70">
                            <mat-label>Pesquisar planos</mat-label>
                            <input matInput
                                [ngModel]="searchTerm"
                                (input)="onSearchInputChanged($event)"
                                placeholder="Digite o nome do plano...">
                            <button mat-icon-button matSuffix *ngIf="searchTerm"
                                (click)="clearSearch()"
                                aria-label="Limpar pesquisa">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <mat-icon matSuffix
                                *ngIf="!searchTerm">search</mat-icon>
                        </mat-form-field>

                        <mat-form-field appearance="outline" fxFlex="15" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="15">
                            <mat-label>Tipo de Sistema</mat-label>
                            <mat-select [(ngModel)]="planFilters.systemType"
                                (selectionChange)="applyPlanFilters()">
                                <mat-option
                                    *ngFor="let type of systemTypeOptions"
                                    [value]="type.value">
                                    {{ type.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" fxFlex="15" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="15">
                            <mat-label>Data de Vencimento</mat-label>
                            <mat-select [(ngModel)]="planFilters.dueDate"
                                (selectionChange)="applyPlanFilters()">
                                <mat-option
                                    *ngFor="let dueDate of dueDateOptions"
                                    [value]="dueDate.value">
                                    {{ dueDate.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>


                    <!-- Indicador do plano selecionado (evita confusao ao editar) -->
                    <div class="selected-plan-banner" *ngIf="selectedPlan">
                        <mat-icon>check_circle</mat-icon>
                        <span class="label">
                            {{ isEditMode ? 'Plano atual:' : 'Plano selecionado:' }}
                            <strong>{{ selectedPlan.systemName || selectedPlan.planDescription || 'Plano' }}</strong>
                        </span>
                        <span class="hint" *ngIf="isEditMode">selecione outro card para trocar</span>
                    </div>

                    <!-- Terminais do plano — pré-preenchido do catálogo, editável para este cliente. -->
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" *ngIf="selectedPlan"
                        style="margin-bottom: 8px;">
                        <mat-form-field appearance="outline" style="width: 220px;">
                            <mat-label>Terminais do plano</mat-label>
                            <input matInput type="number" min="1" step="1"
                                [value]="planTerminalQuantity ?? selectedPlan.terminalQuantity"
                                (change)="setPlanTerminalQuantity($event)">
                        </mat-form-field>
                        <span class="hint">vem do plano selecionado — ajustável para este cliente; a distribuição por filial fica no passo 4.</span>
                    </div>

                    <!-- Conteúdo Principal do Step (Cards e Loading) -->
                    <div class="customer-plan-cards-step"
                        style="overflow-y: auto; min-height: 300px;">
                        <card-grid-responsive
                            *ngIf="!isLoadingPlans && filteredPlans.length > 0"
                            [hasFilter]="false"
                            [hasAdd]="false"
                            [hidePagination]="true"
                            [showLock]="false"
                            [isEditableShow]="false"
                            [isDeletableShow]="false"
                            [showInfo]="true"
                            [lockProperty]="'isActive'"
                            [cardTitleProperty]="'systemName'"
                            [cardImageProperty]="'image'"
                            [showBadge]="true"
                            [badgeProperty]="'typeLabel'"
                            [dataSource]="planCardsDataSource"
                            [displayedColumns]="['planDescription', 'systemLabel', 'terminalQuantity', 'monthlyValue', 'adhesionFee', 'isDaysCountLabel', 'dueDateLabel', 'createdAtLabel', 'partnersLabel']"
                            [configColumns]="planCardColumns"

                            (openShow)="selectPlan($event)"
                            (onSelect)="selectPlan($event)">
                        </card-grid-responsive>
                        <div
                            *ngIf="!isLoadingPlans && filteredPlans.length === 0"
                            class="no-results" fxLayoutAlign="center center"
                            fxLayout="column" fxFlex>
                            <mat-icon>search_off</mat-icon>
                            <span>Nenhum plano encontrado com os filtros
                                aplicados.</span>
                            <button mat-raised-button color="primary"
                                (click)="onSearchNoResults()"
                                style="margin-top: 16px;">
                                <mat-icon>refresh</mat-icon> Limpar e Recarregar
                            </button>
                        </div>
                    </div>

                    <!-- Ações do Step -->
                    <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="end center" fxLayoutAlign.xs="stretch center" fxLayoutAlign.sm="stretch center"
                        fxLayoutGap="10px"
                        style="padding-top: 16px; border-top: 1px solid rgba(0,0,0,0.12);">
                        <button mat-stroked-button color="primary"
                            (click)="cancelSelection()">Cancelar</button>
                        <button mat-raised-button color="primary"
                            (click)="handleSystemConfirmation()"
                            [disabled]="!selectedPlan">
                            Próximo <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- 2. Selecionar Variações do Plano -->
            <mat-step *ngIf="moduleSelectionForm"
                [stepControl]="moduleSelectionForm" label="Variação"
                [optional]="true">
                <ng-template matStepLabel>Selecionar Variações</ng-template>
                <div class="step-content" fxLayout="column">
                    <div fxFlex="40" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="16px">
                        <h2 fxFlexAlign="start">Selecione as Variações do Plano</h2>
                        <p
                            matTooltip="Selecione uma ou mais variações do plano para montar os dados que serão aplicados ao cliente."
                            class="selection-info">
                            <mat-icon>info</mat-icon>
                        </p>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                        <mat-form-field appearance="outline" fxFlex>
                            <mat-label>Pesquisar variações</mat-label>
                            <input matInput [(ngModel)]="moduleSearchTerm"
                                (keyup)="filterModules()"
                                placeholder="Digite nome, código ou solução...">
                            <button mat-icon-button matSuffix
                                *ngIf="moduleSearchTerm"
                                (click)="moduleSearchTerm = ''; filterModules()"
                                aria-label="Limpar pesquisa">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <mat-icon matSuffix
                                *ngIf="!moduleSearchTerm">search</mat-icon>
                        </mat-form-field>
                        <button
                            type="button"
                            mat-fab
                            class="variation-add-fab"
                            (click)="openModulesByPlanSolutionModal()"
                            matTooltip="Ver módulos da solução do plano"
                            aria-label="Ver módulos da solução do plano">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    <div
                        *ngIf="!isLoadingModules && availableVariations && availableVariations.length > 0"
                        fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.xs="start start" fxLayoutAlign.sm="start start">
                        <span class="modules-counter">
                            <b>{{ availableVariations.length }}</b> variações disponíveis
                        </span>
                        <span *ngIf="selectedVariations.length > 0"
                            class="modules-counter selected">
                            <b>{{ selectedVariations.length }}</b> variações selecionadas
                        </span>
                    </div>

                    <div fxFlex="grow"
                        style="overflow-y: auto; min-height: 300px;">
                        <div
                            *ngIf="!isLoadingModules && availableVariations && availableVariations.length > 0"
                            class="modules-grid" fxLayout="row wrap" fxLayoutGap="16px grid">
                            <div *ngFor="let variation of availableVariations"
                                fxFlex="33" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100">
                                <mat-card class="module-card"
                                    [class.selected]="isVariationSelected(variationKey(variation))"
                                    (click)="toggleVariationSelection(variation)">

                                    <div class="module-content">
                                        <div class="module-header">
                                            <mat-icon
                                                class="module-icon">view_module</mat-icon>
                                            <div class="module-name-wrapper">
                                                {{ variation.nome || variation.codigo || 'Variação' }}
                                            </div>
                                            <mat-icon
                                                *ngIf="isVariationSelected(variationKey(variation))"
                                                class="check-icon" color="primary">
                                                check_circle
                                            </mat-icon>
                                        </div>

                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Código:</span>
                                            <span class="info-value">{{ variation.codigo || '--' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Tipo Produto/Solução:</span>
                                            <span class="info-value">
{{ getVariationTypeDescription(variation) }}
                                            </span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Produto/Solução:</span>
                                            <span class="info-value">{{ variation.solucao || 'N/A' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Módulo:</span>
                                            <span class="info-value">{{ getVariationModuleNames(variation) }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Valor de Acesso:</span>
                                            <span class="info-value">{{ (variation.valorMensalidade || 0) | currency:'BRL' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;" *ngIf="!isPartnerUser">
                                            <span class="info-label">Custo:</span>
                                            <span class="info-value">{{ getVariationCost(variation) | currency:'BRL' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Status:</span>
                                            <span class="info-value">{{ variation.status || 'ATIVO' }}</span>
                                        </div>
                                    </div>
                                </mat-card>
                            </div>

                            <div *ngFor="let module of getSelectedExtraModulesForCards()"
                                fxFlex="33" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100">
                                <mat-card class="module-card selected extra-module-card"
                                    (click)="removeExtraModuleSelection(module)">

                                    <div class="module-content">
                                        <div class="module-header">
                                            <mat-icon
                                                class="module-icon">extension</mat-icon>
                                            <div class="module-name-wrapper">
                                                {{ module.name || 'Módulo Extra' }}
                                            </div>
                                            <mat-icon
                                                class="check-icon" color="primary">
                                                check_circle
                                            </mat-icon>
                                        </div>

                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Código:</span>
                                            <span class="info-value">{{ module.id || '--' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Tipo:</span>
                                            <span class="info-value">MÓDULO EXTRA</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Produto/Solução:</span>
                                            <span class="info-value">{{ selectedPlan?.systemName || selectedSystem?.name || 'N/A' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Módulo:</span>
                                            <span class="info-value">{{ module.name || 'N/A' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Valor de Acesso:</span>
                                            <span class="info-value">{{ (module.accessValue || 0) | currency:'BRL' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;" *ngIf="!isPartnerUser">
                                            <span class="info-label">Custo:</span>
                                            <span class="info-value">{{ (module.cost || 0) | currency:'BRL' }}</span>
                                        </div>
                                        <div class="info-row" style="padding: 0 12px 10px;">
                                            <span class="info-label">Status:</span>
                                            <span class="info-value">ATIVO</span>
                                        </div>
                                    </div>
                                </mat-card>
                            </div>
                        </div>

                        <div
                            *ngIf="!isLoadingModules && (!availableVariations || availableVariations.length === 0)"
                            class="no-results" fxLayoutAlign="center center"
                            fxLayout="column" fxFlex>
                            <mat-icon>search_off</mat-icon>
                            <span>Nenhuma variação encontrada para o plano selecionado.</span>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="space-between center" fxLayoutAlign.xs="stretch center" fxLayoutAlign.sm="stretch center"
                        fxLayoutGap="10px"
                        style="padding-top: 16px; border-top: 1px solid rgba(0,0,0,0.12);">
                        <button mat-stroked-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Voltar
                        </button>
                        <div fxLayout="row" fxLayoutGap="10px">
                            <button mat-raised-button color="primary"
                                [disabled]="selectedVariations.length === 0 && availableVariations.length > 0"
                                matStepperNext>
                                Próximo <mat-icon>chevron_right</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- 3. Matriz & Filiais (novo no Core) -->
            <mat-step label="Filiais">
                <ng-template matStepLabel>Matriz &amp; Filiais</ng-template>
                <div class="step-content" fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                        <h2 fxFlexAlign="start">Matriz &amp; Filiais</h2>
                        <p class="selection-info">novo no Core — o Core não tinha etapa de filiais.</p>
                    </div>

                    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" fxLayoutGap="16px"
                        style="margin-bottom: 12px;">
                        <mat-button-toggle-group [value]="perFilialMode" (change)="setPerFilialMode($event.value)">
                            <mat-button-toggle [value]="false">Mesma para todas</mat-button-toggle>
                            <mat-button-toggle [value]="true">Personalizar por filial</mat-button-toggle>
                        </mat-button-toggle-group>

                        <mat-form-field appearance="outline" style="width: 220px;">
                            <mat-label>Máx. de filiais (opcional)</mat-label>
                            <input matInput type="number" min="0" step="1"
                                placeholder="Sem limite"
                                [value]="maxBranches ?? ''"
                                (change)="setBranchesMaxLimit($event)">
                        </mat-form-field>
                    </div>

                    <div style="overflow-y: auto; min-height: 260px;">
                        <table class="branches-table" style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th style="text-align:left; width: 48px;"></th>
                                    <th style="text-align:left;">Filial</th>
                                    <th style="text-align:left;">Documento</th>
                                    <th style="text-align:left; width: 90px;">Selo</th>
                                    <th style="text-align:right; width: 140px;">Valor mensal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of branchRows">
                                    <td>
                                        <mat-checkbox
                                            [checked]="isBranchSelected(row)"
                                            [disabled]="isMatrizRow(row) || isBranchToggleDisabled(row)"
                                            [matTooltip]="isMatrizRow(row) ? 'Matriz obrigatória' : (isBranchToggleDisabled(row) ? 'Máx. de filiais atingido' : '')"
                                            (change)="toggleBranchSelection(row)">
                                        </mat-checkbox>
                                    </td>
                                    <td>{{ row.title }}</td>
                                    <td>{{ row.document || '--' }}</td>
                                    <td><span class="badge" *ngIf="isMatrizRow(row)">MATRIZ</span></td>
                                    <td style="text-align:right;">
                                        {{ (isBranchSelected(row) ? getBranchMonthlyValue(row) : 0) | currency:'BRL' }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div *ngIf="branchRows.length <= 1" class="no-results" fxLayoutAlign="center center" fxLayout="column" fxFlex>
                            <mat-icon>info_outline</mat-icon>
                            <span>Este cliente não possui filiais adicionais cadastradas — apenas a Matriz.</span>
                        </div>

                        <!-- Editor de composição por filial (só no modo "Personalizar por filial") -->
                        <div *ngIf="perFilialMode" class="branch-composition-editor" style="margin-top: 16px;">
                            <div *ngFor="let row of activeBranchRows()" class="branch-composition-panel"
                                style="border: 1px solid rgba(0,0,0,0.12); border-radius: 8px; padding: 12px; margin-bottom: 10px;">
                                <h4 style="margin: 0 0 8px;">{{ row.title }}</h4>
                                <div *ngFor="let item of getCompositionItemsForBranchEditor()" fxLayout="row"
                                    fxLayoutAlign="space-between center">
                                    <mat-checkbox
                                        [checked]="isBranchItemIncluded(row, item)"
                                        (change)="toggleBranchItemInclusion(row, item)">
                                        {{ item.title }}
                                    </mat-checkbox>
                                    <span>{{ item.monthlyValue | currency:'BRL' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="totals-footer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <span class="pill" [class.bad]="branchesLimitExceeded()">
                            Filiais no plano: {{ activeBranchesCount() }}<span *ngIf="maxBranches"> / {{ maxBranches }}</span>
                        </span>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
                        style="padding-top: 16px; border-top: 1px solid rgba(0,0,0,0.12);">
                        <button mat-stroked-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Voltar
                        </button>
                        <button mat-raised-button color="primary" matStepperNext>
                            Próximo <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- 4. Limites por filial (novo no Core) -->
            <mat-step label="Limites">
                <ng-template matStepLabel>Limites por filial</ng-template>
                <div class="step-content" fxLayout="column">
                    <h2 fxFlexAlign="start">Limites por filial</h2>
                    <p class="selection-info">
                        Distribua os {{ planTerminalQuantity ?? selectedPlan?.terminalQuantity ?? 0 }} terminal(is) do
                        plano (definido no passo 1) entre as filiais e defina o máximo de usuários por filial.
                    </p>

                    <div style="overflow-y: auto; min-height: 260px;">
                        <table class="branches-table" style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th style="text-align:left;">Filial</th>
                                    <th style="text-align:left; width: 160px;">Terminais</th>
                                    <th style="text-align:left; width: 160px;">Máx. usuários</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of activeBranchRows()">
                                    <td>{{ row.title }}<span class="badge" *ngIf="isMatrizRow(row)"> MATRIZ</span></td>
                                    <td>
                                        <input type="number" min="0" step="1"
                                            class="summary-value-input summary-value-input--sm"
                                            [class.error]="branchTerminalsExceedPlan()"
                                            [value]="getBranchTerminalQuantity(row) ?? ''"
                                            (change)="setBranchTerminalQuantity(row, $event)">
                                    </td>
                                    <td>
                                        <input type="number" min="0" step="1"
                                            class="summary-value-input summary-value-input--sm"
                                            [value]="getBranchMaxUsers(row) ?? ''"
                                            (change)="setBranchMaxUsers(row, $event)">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="totals-footer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <span class="pill" [class.bad]="branchTerminalsExceedPlan()">
                            Terminais: {{ getBranchTerminalsTotal() }} / {{ planTerminalQuantity ?? selectedPlan?.terminalQuantity ?? 0 }}
                            <span *ngIf="branchTerminalsExceedPlan()"> — excede o plano!</span>
                        </span>
                        <span class="pill">Usuários totais: {{ getBranchUsersTotal() }}</span>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
                        style="padding-top: 16px; border-top: 1px solid rgba(0,0,0,0.12);">
                        <button mat-stroked-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Voltar
                        </button>
                        <button mat-raised-button color="primary" matStepperNext>
                            Próximo <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- 5. Resumo e Finalização -->
            <mat-step label="Resumo">
                <ng-template matStepLabel>Resumo da Seleção</ng-template>
                <div class="step-content" fxLayout="column">
                    <h2 fxFlexAlign="start">Confirme sua Seleção</h2>

                    <div class="summary-container">
                        <!-- Layout em duas colunas -->
                        <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column"
                            fxLayoutGap="16px">
                            <!-- Coluna da esquerda - Plano -->
                            <div fxFlex="1 1 50%" fxFlex.xs="100" fxFlex.sm="100">
                                <!-- Plano Selecionado -->
                                <div *ngIf="selectedPlan" class="summary-card">
                                    <div class="summary-card-header">
                                        <mat-icon>assignment</mat-icon>
                                        <h3>Plano</h3>
                                    </div>
                                    <div class="summary-card-content">
                                        <div class="info-grid">
                                            <div class="info-item">
                                                <span
                                                    class="info-label">Nome:</span>
                                                <span class="info-value">{{
                                                    selectedPlan.systemName ||
                                                    'N/A' }}</span>
                                            </div>
                                            <div class="info-item">
                                                <span
                                                    class="info-label">Tipo:</span>
                                                <span class="info-value">{{
                                                    getSystemTypeDescription(selectedPlan.type)
                                                    }}</span>
                                            </div>
                                            <div class="info-item">
                                                <span
                                                    class="info-label">Terminais:</span>
                                                <span class="info-value">{{
                                                    selectedPlan.terminalQuantity
                                                    }}</span>
                                            </div>
                                            <div class="info-item">
                                                <span
                                                    class="info-label">Vencimento:</span>
                                                <span class="info-value">{{ getSummaryDueDate() }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div fxFlex="1 1 50%" fxFlex.xs="100" fxFlex.sm="100" *ngIf="selectedPlan"
                                class="summary-card">
                                <div class="summary-card-header">
                                    <mat-icon>extension</mat-icon>
                                    <h3>Variações do Plano</h3>
                                </div>
                                <div class="summary-card-content">
                                    <div class="selected-modules-list" *ngIf="getSummaryCompositionItems().length > 0">
                                        <div
                                            *ngFor="let item of getSummaryCompositionItems(); let i = index"
                                            class="selected-module-item">
                                            <div class="module-number">{{ i + 1 }}</div>
                                            <div class="module-details">
                                                <div><strong>{{ item.title }}</strong></div>
                                                <div>Sistema: {{ item.system }}</div>
                                                <div>Módulo: {{ item.module }}</div>
                                                <div class="module-edit-row">
                                                    <span class="module-edit-label">Mensalidade:</span>
                                                    <span class="value-edit">
                                                        <span class="value-edit-prefix">R$</span>
                                                        <input type="number" min="0" step="0.01"
                                                            class="summary-value-input summary-value-input--sm"
                                                            [value]="item.monthlyValue"
                                                            (change)="setCompositionMonthlyValue(item, $event)" />
                                                    </span>
                                                </div>
                                                <div class="module-edit-row">
                                                    <span class="module-edit-label">Adesão:</span>
                                                    <span class="value-edit">
                                                        <span class="value-edit-prefix">R$</span>
                                                        <input type="number" min="0" step="0.01"
                                                            class="summary-value-input summary-value-input--sm"
                                                            [value]="item.adhesionValue"
                                                            (change)="setCompositionAdhesionValue(item, $event)" />
                                                    </span>
                                                </div>
                                                <div class="module-edit-row" *ngIf="!isPartnerUser">
                                                    <span class="module-edit-label">Custo:</span>
                                                    <span class="value-edit">
                                                        <span class="value-edit-prefix">R$</span>
                                                        <input type="number" min="0" step="0.01"
                                                            class="summary-value-input summary-value-input--sm"
                                                            [value]="item.costValue"
                                                            (change)="setCompositionCost(item, $event)" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="no-selection" *ngIf="getSummaryCompositionItems().length === 0">
                                        <mat-icon>info_outline</mat-icon>
                                        <span>Nenhuma variação selecionada.</span>
                                    </div>
                                </div>
                                <div class="summary-card-footer">
                                    <div class="value-item">
                                        <span>Valor Mensal Total:</span>
                                        <span class="value-edit">
                                            <span class="value-edit-prefix">R$</span>
                                            <input type="number" min="0" step="0.01"
                                                class="summary-value-input"
                                                [value]="getSummaryMonthlyValue()"
                                                (change)="setSummaryMonthlyValue($event)" />
                                        </span>
                                    </div>
                                    <div class="value-item">
                                        <span>Taxa de Adesão Total:</span>
                                        <span class="value-edit">
                                            <span class="value-edit-prefix">R$</span>
                                            <input type="number" min="0" step="0.01"
                                                class="summary-value-input"
                                                [value]="getSummaryAdhesionFee()"
                                                (change)="setSummaryAdhesionFee($event)" />
                                        </span>
                                    </div>
                                    <div class="value-item" *ngIf="!isPartnerUser">
                                        <span>Total Custo:</span>
                                        <span class="value-edit">
                                            <span class="value-edit-prefix">R$</span>
                                            <input type="number" min="0" step="0.01"
                                                class="summary-value-input"
                                                [value]="getSummaryCost()"
                                                (change)="setSummaryCost($event)" />
                                        </span>
                                    </div>
                                    <div class="value-item total">
                                        <span>Total:</span>
                                        <span>{{ getTotalValue() | currency:'BRL' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Composição por filial (largura total) -->
                        <div class="summary-card" *ngIf="activeBranchRows().length > 0" style="margin-top: 16px;">
                            <div class="summary-card-header">
                                <mat-icon>store</mat-icon>
                                <h3>Composição por filial</h3>
                            </div>
                            <div class="summary-card-content">
                                <table class="branches-table" style="width: 100%; border-collapse: collapse;">
                                    <thead>
                                        <tr>
                                            <th style="text-align:left;">Filial</th>
                                            <th style="text-align:left; width: 120px;">Terminais</th>
                                            <th style="text-align:left; width: 120px;">Usuários</th>
                                            <th style="text-align:right; width: 140px;">Valor mensal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let row of activeBranchRows()">
                                            <td>{{ row.title }}<span class="badge" *ngIf="isMatrizRow(row)"> MATRIZ</span></td>
                                            <td>{{ getBranchTerminalQuantity(row) ?? '--' }}</td>
                                            <td>{{ getBranchMaxUsers(row) ?? '--' }}</td>
                                            <td style="text-align:right;">{{ getBranchMonthlyValue(row) | currency:'BRL' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Motivo da alteração — obrigatório na edição (Core) -->
                        <div class="summary-card" *ngIf="isEditMode" style="margin-top: 16px;">
                            <div class="summary-card-header">
                                <mat-icon>edit_note</mat-icon>
                                <h3>Motivo da alteração <span class="required-mark">*</span></h3>
                            </div>
                            <div class="summary-card-content">
                                <mat-form-field appearance="outline" style="width: 100%;">
                                    <mat-label>Motivo da alteração</mat-label>
                                    <textarea matInput rows="3"
                                        [value]="updateReason"
                                        (change)="setUpdateReason($event)"
                                        placeholder="Descreva o motivo desta alteração no plano do cliente"></textarea>
                                    <mat-hint>Obrigatório na edição de plano do Core (updateReason).</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Mensagem quando nada foi selecionado -->
                        <div *ngIf="!selectedPlan && !selectedSystem"
                            class="no-selection">
                            <mat-icon>info_outline</mat-icon>
                            <span>Nenhuma seleção foi feita ainda. Por favor,
                                volte e selecione um plano.</span>
                        </div>
                    </div>

                    <!-- Ações do Step -->
                    <div class="wizard-actions">
                        <button mat-stroked-button matStepperPrevious>
                            <mat-icon>chevron_left</mat-icon> Voltar
                        </button>
                        <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10px" fxLayoutGap.xs="2px">
                            <button mat-button color="warn"
                                (click)="resetWizard()">
                                <mat-icon>refresh</mat-icon> Reiniciar
                            </button>
                            <button mat-raised-button color="primary"
                                (click)="finishSelection()"
                                [disabled]="!selectedPlan || !selectedSystem || isUpdateReasonMissing"
                                [matTooltip]="isUpdateReasonMissing ? 'Informe o motivo da alteração para concluir' : ''">
                                {{ isEditMode ? 'Salvar alterações' : 'Adicionar plano' }}
                                <mat-icon>check_circle_outline</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-stepper>
    </div>
</app-dialog-container>
